import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusLarge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlusLarge"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 3V11.25H21V12.75H12.75V21H11.25V12.75H3V11.25H11.25V3H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlusLarge;
